import { aliases, ph } from '#ui-utils/iconify'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('vuetify:before-create', ({ vuetifyOptions }) => {
    vuetifyOptions.icons = {
      defaultSet: 'ph',
      aliases,
      sets: { ph },
    }
  })
})
